import { render, staticRenderFns } from "./testcopedialog.vue?vue&type=template&id=7ced8a1c&scoped=true"
import script from "./testcopedialog.vue?vue&type=script&lang=js"
export * from "./testcopedialog.vue?vue&type=script&lang=js"
import style0 from "./testcopedialog.vue?vue&type=style&index=0&id=7ced8a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ced8a1c",
  null
  
)

export default component.exports